<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<el-container>
			<el-header style="height: auto;padding-left: 0px;"><!--工具条-->
				<!--工具条-->
				<el-col :span="24" class="toolbar">
					<el-form :inline="true" :model="filters" class="filterForm">
						<el-form-item label="答题时间段:" label-width="100px">
							<el-date-picker type="daterange" v-model="addTimes" value-format="yyyy-MM-dd"
								class="formItem" size="small"></el-date-picker>
						</el-form-item>
						<el-form-item label="题目分组:" label-width="110px">
						<el-cascader style="height: auto;" class="formItem300 el-cascader-menu" size="small"
							:options="treeData" :props="defaultProps" v-model="selectedGroupOptions"
							@change="handleGroupChange">
						</el-cascader>
					</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
						</el-form-item>
					</el-form>
				</el-col>
			</el-header>
			<el-container>
				<el-aside width="250px" v-if="1==2"
					style="border: 1px solid #ccc;margin-top:0px;overflow-y: auto;height: calc(100vh - 220px);">
					<el-tree ref="gyszlTree" :data="treeData" node-key="id" :props="defaultProps"
						:default-expanded-keys="defaultKeys" @node-click="handleNodeClick" highlight-current>
						<span class="custom-tree-node" slot-scope="{ node, data }">
							<span>{{ data.isHide == 1 ? '【隐藏】' : '' }}{{ node.label }}</span>
						</span>
					</el-tree>
				</el-aside>
				<el-main style="padding-left: 0px;padding-top: 0px;"> <!--列表-->
					<!--列表-->
					<el-table :data="grid_data" height="calc(100vh - 220px)" border highlight-current-row
						v-loading="listLoading" style="width: 100%;">
						<el-table-column prop="proTypeName" label="题目类型" width="80"></el-table-column>
						<el-table-column prop="proNo" label="题号" width="80"></el-table-column>
						<el-table-column prop="proName" label="题目" width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="proLevelName" label="难度" width="85"></el-table-column>
						<el-table-column prop="gradeName" label="年级" width="100"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="unitName" label="单元" width="85" show-overflow-tooltip></el-table-column>
						<el-table-column prop="chapterName" label="章节" width="85"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="bookVersionName" label="教材版本" width="85"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="totalUserNum" label="学生总数" width="85"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="errorUserNum" label="错误人数" width="85"
							show-overflow-tooltip></el-table-column>
						<el-table-column prop="errorRate" label="错误率%" width="85"
							show-overflow-tooltip></el-table-column>
					</el-table>
					<!--分页-->
					<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
						@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
				</el-main>
			</el-container>
		</el-container>

	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
export default {
	components: { pagination },
	data() {
		return {
			filters: {
				startTime: '',
				startTime2: '',
				schoolId: '',
				teacherId: '',
				chapterId: '',
				gradeId: '',
				unitId: '',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0,
			addTimes: [this.getDefaultDay(),this.getDefaultDay()],
			treeData: [],
			selectedGroupOptions: [],
			defaultProps: {
				children: "children",
				label: "groupName",
				value: "id",
			},
			defaultKeys: [1],
		}
	},
	methods: {
		handleNodeClick(data) {
			if (data.groupType == 1) {
				this.filters.gradeId = data.id
				this.filters.unitId = ''
				this.filters.chapterId = ''
			}
			else if (data.groupType == 2) {
				this.filters.gradeId = ''
				this.filters.unitId = data.id
				this.filters.chapterId = ''
			}
			else if (data.groupType == 3) {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.chapterId = data.id
			}
			else {
				this.filters.gradeId = ''
				this.filters.unitId = ''
				this.filters.chapterId = ''
			}
			this.filters.page = 1
			this.getGridData()
		},
		handleGroupChange(value) {
			this.filters.chapterId = ''
			if (value.length > 2) {
				this.filters.chapterId = value[2]
			}
		},
		//获取列表
		getGridData() {
			this.listLoading = true;
			this.$util.dealQueryDateRange(this.filters, this.addTimes, "startTime")
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/school/getStat_errorexercise_countlist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
	},
	async created() {
		this.treeData = await this.getExerciseGroupTreeData(1)
		this.getGridData();
	}
}

</script>

<style scoped></style>
